import { inject } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import RequestBuilder from '~/builders/http/RequestBuilder'
import {
  LoanInfoResult,
  LoanMerchantName,
  LoanTargetResult
} from '~/models/loan'
import { TBI_DEFAULT_INTEREST, TbiLoanType } from '~/constants/loan/tbi'

@containerScoped()
export default class LoanService {
  constructor(@inject(RequestBuilder) private requestBuilder: RequestBuilder) {}

  getLoanInfo(
    merchantName: LoanMerchantName,
    amount: number,
    installments: number,
    loanType: TbiLoanType
  ): Promise<LoanInfoResult> {
    return this.requestBuilder
      .request('get', `/api/loans/${merchantName}/info/`)
      .params({ amount, installments, loan_type: loanType })
      .send()
  }

  getLoanTarget(
    merchantName: LoanMerchantName,
    amount: number,
    installments: number,
    loanType: TbiLoanType
  ): Promise<LoanTargetResult> {
    return this.requestBuilder
      .request('get', `/api/loans/${merchantName}/target/`)
      .params({ amount, installments, loan_type: loanType })
      .send()
  }

  calculateInstallmentAmount(
    amount: number,
    installments: number,
    interest: number = TBI_DEFAULT_INTEREST
  ): number {
    const loanFee = 100 / installments
    const interestPerMonth = interest / 100 / 12
    const appliedInterest = (1 + interestPerMonth) ** installments
    const monthlyAmount =
      amount * (interestPerMonth / (appliedInterest - 1) + interestPerMonth)
    return monthlyAmount + loanFee
  }
}
